import React from "react";
import Portfolio from "./components/Portfolio";

function App() {
  return (
    <div id="App" className="my-8">
      <Portfolio />
    </div>
  );
}

export default App;
